export const CROP_PROTECTION_KIND = 'sante_vegetal'
export const SEED_KIND = 'semences'
export const SERVICE_KIND = 'services'
export const EQUIPMENT_KIND = 'equipements_exploitant'
export const CULTURE_EQUIPMENT_KIND = 'equipements_culture'
export const VINE_EQUIPMENT_KIND = 'equipement_vigne_arbo'
export const NUTRITION_AMENDMENTS_KIND = 'nutrition_vegetal_amendements'
export const FARM_DEVELOPMENT_KIND = 'amenagement_exploitation'
